module.exports = __webpack_public_path__ + "img/zengzhi.375650be.png";